import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Global 401 handler: if the session expires while working, redirect to login
// (but never on the initial /auth/me check)
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    if (status === 401 && !url.includes("/auth/me") && !url.includes("/auth/login")) {
      // Preserve where the user was so we can return after login
      const path = window.location.pathname + window.location.search;
      if (!path.startsWith("/login") && !path.startsWith("/publico") && !path.startsWith("/telao")) {
        sessionStorage.setItem("fits4you_return_to", path);
        window.location.href = "/login?expired=1";
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Erro inesperado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function extractErrorMessage(err) {
  if (!err) return "Erro desconhecido.";
  if (err.response) {
    const d = err.response.data?.detail;
    if (d) return formatApiErrorDetail(d);
    return `Erro ${err.response.status}: ${err.response.statusText || "sem detalhes"}`;
  }
  if (err.request) return "Sem resposta do servidor. Verifique sua conexão.";
  return err.message || "Erro inesperado.";
}
